import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { useStore } from '@/plugins/store/index';
import { TimePeriod } from '@/types';
import App from './App.vue';
import '@/assets/css/index.css';

const pinia = createPinia();

createApp(App).use(pinia).mount('#app');

const store = useStore();
store.init();

let currentSelectedPeriodKey: string | null = null;

const getSelectedPeriodKey = (state: any): string => {
    const baseId = state.selectedPeriod?.id || '';
    if (baseId === TimePeriod.CustomRange) {
        const from = state.customDateRange?.from || '';
        const to = state.customDateRange?.to || '';
        return `${baseId}:${from}:${to}`;
    }
    return String(baseId);
};

store.$subscribe((mutation, state) => {
    const nextPeriodKey = getSelectedPeriodKey(state);
    if (nextPeriodKey !== currentSelectedPeriodKey) {
        currentSelectedPeriodKey = nextPeriodKey;
        store.getStatistics(true);
    }
});
